export default __webpack_public_path__ + "static/media/settings.d6980c77.svg";